export default __webpack_public_path__ + "static/media/HankRnd-Regular.ef52037d.ttf";